module.exports = __webpack_public_path__ + "assets/10d78ee68d87edb9aa325bbb2c6f8cc2.mp3";